import { translate } from "@/i18n";
import { desktopVoiceMessages } from "@/i18n/messages/desktop-voice";

const ACKNOWLEDGEMENT_KEYS = [
  "acknowledgeGotIt",
  "acknowledgeOkay",
  "acknowledgeOnIt",
  "acknowledgeSure",
] as const;

const CONVERSATIONAL_PROMPT_PATTERNS = [
  /^(hi|hey|hello|yo|hiya|howdy|sup)\b[\s,!.?]*(there|denker)?[\s,!.?]*$/i,
  /^(good\s+)?(morning|afternoon|evening|night)\b[\s,!.?]*(there|denker)?[\s,!.?]*$/i,
  /^(hi|hey|hello|yo|hiya|howdy|sup)\b[\s,!.?]*(what'?s|what is)\s+(up|your name)[\s?!.]*$/i,
  /^(what'?s|what is)\s+your\s+name[\s?!.]*$/i,
  /^who\s+are\s+you[\s?!.]*$/i,
  /^how\s+are\s+you[\s?!.]*$/i,
  /^what\s+can\s+you\s+do[\s?!.]*$/i,
  /^what\s+models?\s+do\s+you\s+use[\s?!.]*$/i,
] as const;

/** A [NAME:text] prompt token. The text has no bracket except a "[" that does
 *  not start another token; stopping at the next token start keeps the scan
 *  linear (a plain `[^\]]+` re-read the rest of the prompt from each
 *  "[NAME:"). Unrolled — a plain run, then "[" plus a plain run — so no regex
 *  engine keeps backtracking state per character. `(?!\])` keeps it non-empty. */
const PROMPT_TOKEN_RE =
  /\[[A-Z_]+:(?!\])[^[\]]*(?:\[(?![A-Z_]+:)[^[\]]*)*\]\s*/g;

function hashText(text: string): number {
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function shouldSpeakAcknowledgementForPrompt(
  promptText?: string,
): boolean {
  const prompt = (promptText ?? "")
    .replace(PROMPT_TOKEN_RE, "")
    .replace(/\s+/g, " ")
    .trim();
  if (!prompt) return false;
  return !CONVERSATIONAL_PROMPT_PATTERNS.some((pattern) =>
    pattern.test(prompt),
  );
}

export function acknowledgementForExecution(executionId?: string): string {
  const key = executionId || String(Date.now());
  const index = hashText(key) % ACKNOWLEDGEMENT_KEYS.length;
  return translate(desktopVoiceMessages, ACKNOWLEDGEMENT_KEYS[index]!);
}

export function isAcknowledgementForExecution(
  text: string,
  executionId: string,
): boolean {
  return text.trim() === acknowledgementForExecution(executionId);
}
